<template>
  <gj-table
      :index="false"
      :loading="loading"
      border
      :data="tableData"
      :columns="columns"
      :show-overflow="false"
      :min-height="400"
      :offset-height="65">
    <template v-slot:sku="{row}">
      <div>
        <gj-text>{{row.productName | defaultShow}}</gj-text>
      </div>
      <div>{{row.sku | defaultShow}}</div>
      <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
    </template>
    <template #footer>
      <div v-gutter="20" class="default">
        <span>产品种类数：{{ productType }}</span>
        <span>入库量合计：{{ storageTotal }}</span>
        <span>总入库金额合计：{{ tableData[0] && tableData[0].priceCurrencySymbol }}{{tableData | sum('amount') | amount }}</span>
        <span>总入库费用合计：{{ tableData[0] && tableData[0].feeCurrencySymbol }}{{tableData | sum('inboundFee') | amount }}</span>
      </div>
    </template>
  </gj-table>
</template>

<script>
  import {getPurchaseOrderInbound} from "../../../../../../../../api/purchase";
  import {ProductEnum} from "../../../../../../../../utils/options";

  export default {
    name: "app-op-purchase-order-inbound",
    props: {
      purchaseOrder: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        loading: false,
        columns: [
          {id: 'inboundCode', header: '入库单号', field: 'inboundCode', width: '140px', fixed: 'left'},
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px', fixed: 'left'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '200px', fixed: 'left'},
          {id: 'deliveryQuantity', header: '交货量', field: 'deliveryQuantity', width: '80px', align: 'right'},
          {id: 'includeTaxPrice', header: '含税单价', field: 'includeTaxPrice', prefix: 'priceCurrencySymbol', width: '100px', align: 'right'},
          {id: 'amount', header: '入库金额', field: 'amount', prefix: 'priceCurrencySymbol', width: '100px', align: 'right'},
          {id: 'unitFee', header: '单位费用', field: 'unitFee', prefix: 'feeCurrencySymbol', width: '100px', align: 'right'},
          {id: 'inboundFee', header: '入库费用', field: 'inboundFee', prefix: 'feeCurrencySymbol', width: '100px', align: 'right'},
          {id: 'changeQuantity', header: '入库良品量', field: 'changeQuantity', width: '120px', align: 'right'},
          {id: 'changeBadQuantity', header: '入库次品量', field: 'changeBadQuantity', width: '120px', align: 'right'},
          {id: 'expectDeliveryDate', header: '预计交货日期', field: 'expectDeliveryDate', width: '120px'},
          {id: 'actualDeliveryDate', header: '实际交货日期', field: 'actualDeliveryDate', width: '120px'},
          {id: 'memo', header: '备注', field: 'memo', minWidth: '250px'},
        ],
        productTypeOption: ProductEnum.typeOption
      }
    },
    created() {
      this.loading = true;
      getPurchaseOrderInbound(this.purchaseOrder.id)
        .then(data => {
          this.tableData = data;
        })
        .complete(() => this.loading = false);
    },
    computed: {
      currencySymbol() {
        if (this._.isEmpty(this.tableData)) {
          return '';
        }
        return this.tableData[0].currencySymbol;
      },
      // 产品种类
      productType() {
        let obj = {}
        return this.tableData.reduce((total, item) => {
          if (!obj[item.sku]) {
            total++
            obj[item.sku] = item
          }
          return total
        }, 0)
      },
      // 入库量合计
      storageTotal() {
        return this.tableData.reduce((total, item) => {
          total = total + Number(item.changeQuantity) + Number(item.changeBadQuantity)
          total = Math.floor(total)
          return total
        }, 0)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
